import { Record } from "immutable";

const defaults = {
    id: "",
    filename: "Attachment",
    display_name: "Attachment",
    hidden: true,
    page_id: "",
    redirect: false,
    size_bytes: "0",
    type: "page_attachment",
    upload_id: "",
    url: "",
    created_at_ms: "",
    modified_at_ms: "",
};

class Attachment extends Record(defaults) {}

export default Attachment;
